export default "__VITE_ASSET__CwShYerD__"